import axios from '../common/axios';

export const getQuantitiesInsights = async productId => {
  const response = await axios.get(
    `stockHistories/getQuantities?productId=${productId}`,
  );
  return response.data.content;
};

export const getProducts = async () => {
  const response = await axios.get('/products/search');
  return response.data.content.results;
};

export const createSourcingRequest = async data => {
  const response = await axios.post('/sourcing/request', data);
  return response.data.content;
};
